<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>

         <v-card class="mb-4">
            <v-card-text class="d-flex align-center py-3">
               <v-switch
                  v-model="moduleEnabled"
                  :loading="moduleLoading"
                  color="primary"
                  hide-details
                  class="mt-0 pt-0"
                  @change="toggleModule"
               ></v-switch>
               <span class="ml-2 font-weight-medium">
                  Election Module {{ moduleEnabled ? 'Enabled' : 'Disabled' }}
               </span>
            </v-card-text>
         </v-card>

         <v-row>
            <v-col cols="12">
               <table-elections></table-elections>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableElections from './Tables/TableElections.vue';
const axios = require('axios')

export default {
   name: "MOAElections",

   props: ['user'],

   data() {
      return {
         page: {
            title: "Manage Elections",
         },
         breadcrumbs: [
            {
               text: "Dashboard",
               disabled: false,
               to: "/dashboard",
            },
            {
               text: "Elections",
               disabled: true,
            },
         ],
         moduleEnabled: true,
         moduleLoading: false,
      }
   },

   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TableElections,
   },

   mounted() {
      this.loadModuleStatus()
   },

   methods: {
      loadModuleStatus() {
         this.moduleLoading = true
         axios.get('/admin/modules/election')
            .then((resp) => {
               if (resp.data && resp.data.status === 'OK' && resp.data.data) {
                  this.moduleEnabled = !!Number(resp.data.data.isenabled)
               }
            })
            .finally(() => { this.moduleLoading = false })
      },
      toggleModule(value) {
         this.moduleLoading = true
         axios.post('/admin/modules/election', { isenabled: value ? 1 : 0 })
            .catch(() => {
               this.moduleEnabled = !value
            })
            .finally(() => { this.moduleLoading = false })
      },
   },

   computed: {

   }

};
</script>

<style>
</style>